<template>
    <tr class="relative">
        <!-- <td class="lg:py-2 pt-4 block lg:table-cell" :class="[i != 0 ? 'border-t border-grey-500' : '']">
            <p class="text-15 font-semibold" v-if="r.contact_id == null">Unknown caller</p>

            <NuxtLink no-prefetch class="text-15 font-semibold underline" :to="'/contacts/' + r.contact_id" v-if="r.contact_id != null">{{ r.first_name }} {{ r.last_name }} </NuxtLink>

            <p class="text-14 text-grey-900">{{ $help.e164ToNumber(r.phone_number) }}</p>
        </td> -->
        <td class="p-0 lg:py-2 block lg:table-cell" :class="[i != 0 ? 'lg:border-t border-grey-500' : '']">
            <template v-if="r.id != null">
                <NuxtLink no-prefetch class="link-text text-15 font-semibold" :to="'/contacts/' + r.id">{{ r.fullName() }}</NuxtLink>
                <p class="text-14 text-grey-900">{{ r.getPrimaryNumber() }}</p>
                <p
                    class="text-14 text-grey-900"
                    v-html="
                        r.addressOverview(
                            {
                                addr: true,
                                addr2: false,
                                town: true,
                                postcode: true,
                            },
                            true,
                        )
                    "
                ></p>
            </template>

            <p class="text-14 text-grey-900 hidden lg:block" v-else>N/A</p>
        </td>
        <td
            class="pb-4 lg:py-2 block lg:table-cell"
            :class="[i != 0 ? 'lg:border-t border-grey-500' : '', r.current_deal != null ? 'pt-4' : '']"
        >
            <p class="text-14 text-grey-900 hidden lg:block" v-if="r.current_deal == null">N/A</p>

            <NuxtLink no-prefetch class="link-text text-15 font-semibold" :to="'/deal/' + r.current_deal.id" v-if="r.current_deal != null"
                >{{ r.current_deal.getName() }}
            </NuxtLink>
            <p class="text-14 text-grey-900" v-if="r.current_deal != null">
                Quoted: {{ $help.dp(r.current_deal.quoted) }} <br />Profit: {{ $help.dp(r.current_deal.profit) }}
            </p>
        </td>
        <td
            class="w-4.5 py-2 pt-3 block lg:table-cell absolute top-4 lg:top-[unset] lg:relative right-0"
            :class="[i != 0 ? 'lg:border-t border-grey-500' : '']"
        >
            <button class="w-4.5 h-4.5" v-if="phoneNumbers.length == 1" @click="call(phoneNumbers)">
                <IconPhone class="w-4.5 h-4.5 stroke-black" />
            </button>

            <DropdownV2 v-else buttonCSS="h-12 icon-hover">
                <template #button>
                    <IconPhone class="w-4.5 h-4.5" />
                </template>
                <template #menu>
                    <div class="table-multi-select-menu bg-black min-w-[260px]">
                        <button v-for="pn in phoneNumbers" @click="call(pn)">{{ $help.e164ToNumber(pn) }}</button>
                    </div>
                </template>
            </DropdownV2>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        r: Object,
        i: Number,
    },

    methods: {
        call(number) {
            this.$event.$emit('make-call', { number: number, id: this.r.id, type: 102, name: this.r.fullName(), link: this.r.view() })
            this.$emit('close')
        },
    },

    computed: {
        phoneNumbers() {
            return this.r.communications
                .filter((c) => {
                    return c.type == 0
                })
                .map((c) => {
                    return c.value
                })
        },
    },
}
</script>
